// extracted by mini-css-extract-plugin
export default {"zoomControls":"Q--z","zoomControlButton":"R--z","zoomBanner":"S--z","bannerButton":"T--z","imageButton":"U--z","zoom":"V--z","zoomContent":"W--z"};